<template >
  <base-dialog-form ref="uploadFotoGaraDialog" :title="title" height="90vh" :text="$t('upload_match_participants_photo')"
    color="secondary" icon="mdi-trophy-outline">
    <template v-slot:actions>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" @click="uploadFoto" :disabled="!image" color="success">{{ $t("upload") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <form>

      <v-row>
        <div style="width:400px; padding:25px;">
          <my-img-uploader ref="imageUploader" v-model="image" :width="300" :height="300"
            :placeholder="$t('click_drag_here')"></my-img-uploader>
        </div>
        <div style="width: calc(100% - 400px);">
          <DataTables :headers="headers" :selected="selected" :showSelect="image !== null" itemKey="ragSoc"
            v-model="selected" :tableData="listUsers"></DataTables>
        </div>

      </v-row>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyImageUploader from "@/components/base/MyImageUploader.vue";
import DataTables from "@/components/base/DataTables.vue";


export default {
  name: "upload-foto-gara",

  components: {
    "my-img-uploader": MyImageUploader, DataTables
  },
  data() {
    return {
      idGara: null,
      image: null,
      title: null,
      selected: null,
      listUsers: [],
      headers: [
        { text: this.$t("photo"), value: "image", type: "image" },
        { text: this.$t("ragSoc"), value: "ragSoc" },
        { text: this.$t("count"), value: "conta" }
      ],
    };
  },
  methods: {
    open(idGara) {
      this.idGara = idGara;
      this.$refs.uploadFotoGaraDialog.open();
      this.loadData();
    },
    uploadFoto() {
      let _ = this;
      _.$refs.imageUploader.updateImage();
      _.chiamataAxios(
        "PUT",
        "/auth/eventi/uploadFotoGara/" + _.idGara,
        { body: { ragSocList: _.selected, image: _.image } }
      ).then((resp) => {
        if (resp.msg.severity === 0) {
          let html = "<strong>" + resp.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.loadData();
        }
      });
    },
    loadData() {
      let _ = this;
      _.isFetching = true;
      _.image = null;
      _.title = null;
      _.selected = null;
      if (_.idGara !== null) {
        _.chiamataAxios("GET", "/auth/eventi/getGaraPartecipanti/" + _.idGara).then(
          (response) => {
            _.title = response.data.titolo;
            _.listUsers = response.data.partecipanti;
          }
        );
      }
    },
  },
  computed: {

  },
  mounted() {
    let _ = this;
    _.loadData();
  },
  watch: {
    idGara: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>
<style></style>